<template>
    <div class="container">

            <div class="topView">
                    <div class="topLiftView" @click="toIntegralDetail()">
                        <div class="topLift_top">
                            <span  class="topLift_top_span">我的积分</span>
                            <img class="topLift_top_icon" src="../../assets/images/icon_indicator_next.png" />
                        </div>
                        <span class="topLeft_span">{{integrationSum}}</span>

                    </div>
                    <div class="topRightView">
                        <div class="topRight_div" @click="tojifengshouche()">
                            <img class="topRight_div_icon" src="../../assets/images/icon_mall_task.png"/>
                            <span class="topRight_div_span">去赚积分</span>
                        </div>
                        <div class="topRight_div_line"></div>

                        <div class="topRight_div" @click="toExchangeRecords()">
                            <img class="topRight_div_icon" src="../../assets/images/icon_mall_record.png"/>
                            <span class="topRight_div_span">我的兑换</span>
                        </div>

                    </div>
            </div>

            <div class="nodate" v-if="isLoad &&selectIndex ==0 && mbActiveList.length==0 ">
                    <span class="nodate_span">积分商城，敬请期待~</span>
             </div>
            <div class="bodyView" v-else>
                    <div class="bodyViewTop">
                        <img class="bodyViewTop_icon" src="../../assets/images/img_mall_integral.png" />
                        <!-- <div class="bodyViewTop_icon"></div>
                        <div class="bodyViewTop_center" @click="toExchangeItemDetails(1)">
                            <span class="bodyViewTop_center_span1">积分兑换</span>
                            <span class="bodyViewTop_center_span2">好物随心换</span>
                        </div>

                        <div class="bodyViewTop_icon"></div> -->
                    </div>

                    <div class="bodyViewWscroll" ref="bodyViewWscroll" v-if="mbActiveGoodsTypeList &&mbActiveGoodsTypeList.length>0">
                        <div class="scrollTab" ref="scrollTab" >
                            <div :ref="`scrollItem_${index}`"
                            v-for="(item,index) in mbActiveGoodsTypeList" :key="index" >
                                <div v-if="index==selectIndex" class="scrollItem">{{item}}</div>
                                <div v-else class="scrollItem1" @click="scrollItemClick(item,index)"  >{{item}}</div>
                            </div>

                        </div>
                    </div>
            </div>
            <div class="shop_list1" v-if="mbActiveList.length>0">
                <scroll  :allLoaded="allLoaded" :data="mbActiveList"  @pulldown="loadData" @loadUp="loadup" >
                    <div class="bodyViewList">
                            <div  class="bodyViewListItem"
                                    v-for="(item,index) in mbActiveList" :key="index" @click="toExchangeItemDetails(item)" >
                                    <!-- <img class="bodyViewListItem_icon" v-if="item.templateType=='1'" src='../../assets/images/img_mall_zfq.png' /> -->
                                    <!-- v-else -->
                                    <img  class="bodyViewListItem_icon" :src="item.actImgPath" />
                                    <span class="bodyViewListItem_span1">{{item.actName}}</span>
                                    <span class="bodyViewListItem_span2">{{item.exchangeValue}}积分</span>
                            </div>
                    </div>

                </scroll>
            </div>
    </div>
</template>

<script>

import {getMbActiveGoodsTypeList ,getMbActiveList} from "../../utils/api";
import { mapState } from 'vuex'
import BScroll from "better-scroll";
import Scroll from '../../components/scroll';
export default {
  name: "IntegralMall",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  components: {
      Scroll,
  },
  data() {
    return {
      allLoaded:true,
      isLoad:false,
      mbActiveGoodsTypeList:[],
      integrationSum: 0,
      mbActiveList: [],
      type:'全部',
      selectIndex:0,
      pageNo:1,
    }
  },
  created () {
      this.getMbActiveGoodsTypeList()
      this.getMbActiveList();
      
  },
  activated(){
    // 只刷新积分
    this.getIntegrationSum()

  },
  mounted(){
    this.$nextTick(() => {
      this.personScroll();
    });
    //this.getData();
  },
 methods: {

  //获取类型
   getMbActiveGoodsTypeList() {
       var param = {
            // "cityId": "010",
            // "marketId": "25",
            "cityId":this.common.marketInfo.cityId,
            "marketId":this.common.marketInfo.id,
            //'25',
            //
        }
       getMbActiveGoodsTypeList( param).then(res => {
          if (res.res.code === 10000) {
                var list = res.body.mbActiveGoodsTypeList;
                var allList =[];
                allList.push("全部");
                this.mbActiveGoodsTypeList = [...allList, ...list];

                setTimeout(() => {
                    this.personScroll();
                }, 100)

          }
        });
    },
    getIntegrationSum(){
        var param = {
            "memberCode": this.common.userInfo.memberCode,
            "type": this.type,
            "pageSize": 10,
            "pageNo": 1,
           // "marketId": '25',
            "marketId":this.common.marketInfo.id,
        }
        getMbActiveList( param).then(res => {
            if (res.res.code === 10000) {
                this.integrationSum= res.body.integrationSum
            }
        })

    },
    ////获取兑换活动列表
    getMbActiveList(){
         var param = {
            "memberCode": this.common.userInfo.memberCode,
            "type": this.type,
            "pageSize": 10,
            "pageNo": this.pageNo,
           // "marketId": '25',
            "marketId":this.common.marketInfo.id,
        }
        getMbActiveList( param).then(res => {
            this. isLoad =true;
            if (res.res.code === 10000) {
                 var list = res.body.mbActiveList;
                 this.integrationSum= res.body.integrationSum
                if (this.pageNo === 1) {
                    this.mbActiveList =  list ;
                     setTimeout(() => {
                        this.personScroll();
                    }, 100)
                } else {
                    this.mbActiveList = this.mbActiveList.concat(list )
                }
                if(!list ){
                    this.allLoaded =true
                } else if(list.length%10==0){
                    this.allLoaded =false
                }else{
                    this.allLoaded =true;
                }
          }
        });

    },
   // 积分记录
    toIntegralDetail(){
         this.$router.push({
           path:'/IntegralDetail'
        })
    } ,
    toExchangeRecords(){
         this.$router.push({
           path:'/ExchangeRecords'
        })
    },

    tojifengshouche(){
        //只做同创 其他项目屏蔽
       // https://h5.topchainspace.com/policyDetail?id=05FEAC114E4F4039BAF47B7183237361&cityId=5
        //  var url ='/policyDetail?id=05FEAC114E4F4039BAF47B7183237361'
        //  this.$router.push({
        //    path:url
        // })
    },

    toExchangeItemDetails(item){
         this.$router.push(`/ExchangeItemDetails?id=${item.id}`);
    },
    personScroll() {
        // 默认有六个li子元素，每个子元素的宽度为120px
            let width = 0;
            //10 * 128;
            if(!this.$refs.scrollTab){
                return;
            }
            for(var i=0;i<this.mbActiveGoodsTypeList.length;i++){
               console.log(this.$refs[`scrollItem_${i}`][0]);
                console.log(this.$refs[`scrollItem_${i}`]);
               console.log(this.$refs[`scrollItem_${i}`][0].style.width);
               width= width+  this.$refs[`scrollItem_${i}`][0].clientWidth +30;
               // width =width+56+ 4*26+20;
                console.log(width);

            }
            this.$refs.scrollTab.style.width = width + "px";
            // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
            this.$nextTick(() => {
                if (!this.scroll) {
                this.scroll = new BScroll(this.$refs.bodyViewWscroll, {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    // 忽略竖直方向的滚动
                    scrollY: false,
                    eventPassthrough: "vertical"
                });
                } else {
                    this.scroll.refresh();
                }
            });
    },
        // personScrollBottom() {
        //   // 默认有六个li子元素，每个子元素的宽度为120px
        //   let height = 10 * 80;
        //   this.$refs.fangCon_item.style.height = height + "px";
        //   // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
        //   this.$nextTick(() => {
        //     if (!this.scroll) {
        //       this.scroll = new BScroll(this.$refs.fangCon, {
        //         startX: 0,
        //         click: true,
        //         scrollY: true,
        //         // 忽略竖直方向的滚动
        //         scrollX: false,
        //         eventPassthrough: "vertical"
        //       });
        //     } else {
        //       this.scroll.refresh();
        //     }
        //   });
        // },

      loadup () {
        if (this.allLoaded) {
            return;
        }
        this.pageNo++;
        this.getMbActiveList();
    },
    loadData () {
        this.allLoaded=false;
        this.pageNo = 1;
        this.getMbActiveList();
    },

    scrollItemClick(item,index){
        this.allLoaded=false;
        this.type=item;
        this.selectIndex=index;
        this.pageNo = 1;
        this.getMbActiveList();

    }
 }

}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    width:100%;
    height: 100vh;
    position: relative;
    background:rgba(255,255,255,1);
    .flex(column);
    .shop_list1 {
        // width:100%;
        flex: 1;
        height: 500px;
        // flex-direction: row;
        // flex-wrap: wrap;
        // margin-bottom: 20px;
    }

}
.topView{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width:100%;
    height:240px;
    background:linear-gradient(90deg,rgba(255,176,0,1) 0%,rgba(255,114,0,1) 100%);
    .topLiftView{
        display: flex;
        margin-left: 40px;
        margin-top: 50px;
        flex-direction: column;
        .topLift_top{
            display: flex;
            .topLift_top_span{
                height:40px;
                font-size:28px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:40px;
            }
            .topLift_top_icon{
                margin-left: 12px;
                margin-top: 12px;
                width:8px;
                height:16px;
            }
        }
        .topLeft_span{
            height:100px;
            font-size:72px;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:100px;
        }

    }
    .topRightView{
        display: flex;

        margin-right: 66px;
        margin-top: 50px;
        flex-direction: row;
        .topRight_div_line{
            width: 70px;
            display: flex;
            // background-color: red;
        }
        .topRight_div{
             width: 104px;
            flex-direction: column;
            .topRight_div_icon{
                margin-left: 6px;
                width: 92px;
                height: 92px;
            }
            .topRight_div_span{
                margin-top: 12px;
                width:104px;
                height:36px;
                font-size:26px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:36px;
            }
        }

    }
}
.nodate{
    flex: 1;
    width: 100%;
    background-color: #ffffff;
    display: flex;
    .nodate_span{
        margin-top: 278px;
        width: 100%;
        text-align: center;
        height:44px;
        font-size:32px;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:44px;
    }
}

.bodyView{
    width: 100%;
    flex-direction: column;
    .bodyViewTop{
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 140px;
        .bodyViewTop_icon{
            width: 340px;
            height: 82px;
        }
        // .bodyViewTop_icon{
        //     width: 100px;
        //     height: 16px;
        //     background-color: blue;
        // }
        .bodyViewTop_center{
            margin-left: 25px;
            margin-right: 25px;
            flex-direction: column;
            align-items: center;
            width: 136px;
            display: flex;
            .bodyViewTop_center_span1{
                // width:136px;
                height:48px;
                font-size:34px;
                color:rgba(51,51,51,1);
                line-height:48px;
            }
            .bodyViewTop_center_span2{
                // width:136px;
                height:48px;
                font-size:24px;
                color:rgba(153,153,153,1);
                line-height:34px;
            }
        }
    }
    .bodyViewWscroll{
        height: 100px;
        width:750px;
        // background-color: red;
        // display: flex;
        align-items: center;
        .scrollTab {
            height: 100px;
            // background-color: orange;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding-left: 28px;
            padding-right: 28px;

        }
         .scrollItem{
                padding-bottom: 10px;
                padding-top: 10px;
                padding-left: 28px;
                padding-right: 28px;
                margin-right: 20px;
                height:56px;
                border-radius:8px;
                text-align: center;
                border:2px solid rgba(255,126,30,1);
                height:36px;
                font-size:26px;
                font-weight:500;
                color:rgba(255,126,30,1);
                line-height:36px;
            }
            .scrollItem1{
                padding-bottom: 10px;
                padding-top: 10px;
                padding-left: 28px;
                padding-right: 28px;
                margin-right: 20px;
                height:56px;
                border-radius:8px;
                text-align: center;
                background:rgba(244,244,244,1);
                // border:2px solid rgba(255,126,30,1);
                height:36px;
                font-size:26px;
                font-weight:500;
                color:#333333;
                line-height:36px;

            }
    }


}

 .bodyViewList{
       width:100%;
      // flex: 1;
    //    height: 500px;
       display: flex;
       flex-direction: row;
       flex-wrap: wrap;
       margin-bottom: 20px;


  .bodyViewListItem{
            margin-top: 20px;
            margin-left: 20px;
            width:344px;
            height:392px;
            background:rgba(255,255,255,1);
            border-radius:8px;
            border:1px solid rgba(234,234,234,1);
            display: flex;
            flex-direction: column;
            .bodyViewListItem_icon{
                width:344px;
                height:256px;
                //background-color: blue;
                background:rgba(226,226,226,1);
                border-radius:8px 8px 0px 0px;
            }
            .bodyViewListItem_span1{
                margin-top: 20px;
                margin-left: 20px;
                height:40px;
                font-size:28px;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:40px;
                .textOver(320px);


            }
            .bodyViewListItem_span2{
                margin-top: 10px;
                margin-left: 20px;
                height:40px;
                font-size:28px;
                font-weight:500;
                color:rgba(255,126,30,1);
                line-height:40px;
                 .textOver(320px);

            }


       }
 }

</style>